export default {
  REQUEST_STATUS_NEVER_GENERATED: 1,
  REQUEST_STATUS_YOUTUBE_NOT_CONNECTED: 2,
  REQUEST_STATUS_VIDEO_OUT_OF_DATE: 3,
  REQUEST_STATUS_ARCHIVED: 4,
  REQUEST_STATUS_RUNNING: 5,
  REQUEST_STATUS_YOUTUBE_UPLOAD_PENDING: 6,
  REQUEST_STATUS_YOUTUBE_UPLOADED: 7,
};
